module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics analytics-customers"
  }, [_c('row', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Customer.generalStatus'),
      "name": "first"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerGrowthChart')))]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.first.customersRadio),
      callback: function($$v) {
        _vm.first.customersRadio = $$v
      },
      expression: "first.customersRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.first.customersOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFirstCustomersOp('week', 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.first.customersOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFirstCustomersOp('month', 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.first.customersOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFirstCustomersOp('year', 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "firstCustomers",
    attrs: {
      "options": _vm.first.customersOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Customer.customerCategories'),
      "name": "third"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "box-header with-border ui-sortable-handle",
    staticStyle: {
      "cursor": "move"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerCategories')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sl-body"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerStatus')))]), _vm._v(" "), _c('div', {
    staticClass: "chart col-lg-3"
  }, [_c('chart', {
    ref: "thirdCustomerStatus",
    attrs: {
      "options": _vm.third.customerStatusOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.third.customerStatusTable,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Analytics.Customer.t1h1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label",
          style: ({
            backgroundColor: scope.row.color
          })
        }, [_vm._v("  ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.category))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "300",
      "show-overflow-tooltip": true,
      "prop": "def",
      "label": _vm.$t('Views.Analytics.Customer.t1h2')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250",
      "show-overflow-tooltip": true,
      "prop": "value",
      "label": _vm.$t('Views.Analytics.Customer.t1h3')
    }
  })], 1)], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerFrequency')))]), _vm._v(" "), _c('div', {
    staticClass: "chart col-lg-3"
  }, [_c('chart', {
    ref: "thirdCustomerFrequency",
    attrs: {
      "options": _vm.third.customerFrequencyOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.third.customerFrequencyTable,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Analytics.Customer.t2h1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label",
          style: ({
            backgroundColor: scope.row.color
          })
        }, [_vm._v("  ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.category))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "300",
      "show-overflow-tooltip": true,
      "prop": "def",
      "label": _vm.$t('Views.Analytics.Customer.t2h2')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250",
      "show-overflow-tooltip": true,
      "prop": "value",
      "label": _vm.$t('Views.Analytics.Customer.t2h3')
    }
  })], 1)], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerContribution')))]), _vm._v(" "), _c('div', {
    staticClass: "chart col-lg-3"
  }, [_c('chart', {
    ref: "thirdCustomerContribution",
    attrs: {
      "options": _vm.third.customerContributionOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.third.customerContributionTable,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Analytics.Customer.t3h1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label",
          style: ({
            backgroundColor: scope.row.color
          })
        }, [_vm._v("  ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "300",
      "show-overflow-tooltip": true,
      "prop": "def",
      "label": _vm.$t('Views.Analytics.Customer.t3h2')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250",
      "show-overflow-tooltip": true,
      "prop": "value",
      "label": _vm.$t('Views.Analytics.Customer.t3h3')
    }
  })], 1)], 1)])], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Customer.ARPC'),
      "name": "fourth"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-2"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.arpcByOutlet')))]), _vm._v(" "), _c('chart', {
    ref: "fourthOutlet",
    attrs: {
      "options": _vm.fourth.outletOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ec70cc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/analytics/customers.vue
// module id = 1082
// module chunks = 1